import React from "react";
import { PhotoView } from "react-photo-view";
import { Link } from "react-router-dom";

const ServicesCard = ({ service }) => {
  const { _id, title, photo, description,price } = service;

  
  return (
    <div>
      <div className="w-full md:w-2/3 my-4 mx-auto px-4">
        <div className="relative m-0 shadow-lg flex bg-white">
          <div className="flex-no-shrink">
            <PhotoView src={photo}>
            <img
              alt=""
              className="md:w-[300px] md:h-[300px] w-[150px] h-[150px] pt-8 object-cover block mx-auto"
              src={photo}
            />
            </PhotoView>
          </div>
          <div className="flex-1  card-block relative">
            <div className="p-6">
              <h4 className="font-medium text-2xl mb-3">{title}</h4>
              <p className="leading-normal">
                {description.slice(0, 100) + "..."}
              </p>
            <p className="font-bold">${price}</p>

              <Link to={`/services/${_id}`}>
                <button className="btn btn-ghost">View Detail</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesCard;
